
import * as React from "react";
import {NavMain} from "@/components/nav-main";
import {ProjectSwitcher} from "@/components/project-switcher";
import {NavUser} from "@/components/nav-user";
import {TeamSwitcher} from "@/components/team-switcher";
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarRail,
} from "@/components/ui/sidebar";
import {LucideIcon, SquareTerminal, Users, LineChart, BarChart3, MessageSquare, Brain, CreditCard, Link, Bell, Settings, Webhook, ShieldCheck} from "lucide-react";
import {User} from "@/features/user";
import { useLocation, Link as RouterLink } from "react-router-dom";

interface DashboardSidebarProps {
    user: User;
}

export function DashboardSidebar({
                                     user,
                                 }: DashboardSidebarProps) {
    const location = useLocation();
    const currentPath = location.pathname;

    // Navigation items for the sidebar
    const navItems = [
        {
            title: "Dashboard",
            url: "/dashboard",
            icon: BarChart3,
            isActive: currentPath === '/dashboard' || currentPath.includes('/project') && (currentPath.includes('/dashboard') || currentPath.includes('/overview')),
        },
        {
            title: "Teams",
            url: "/teams",
            icon: Users,
            isActive: currentPath === '/teams' || currentPath.includes('/teams'),
        },
        {
            title: "Analytics",
            url: "/analytics",
            icon: LineChart,
            isActive: currentPath === '/analytics',
        },
        {
            title: "ESG Dashboard",
            url: "/esg-dashboard",
            icon: ShieldCheck,
            isActive: currentPath === '/esg-dashboard',
        },
        {
            title: "Page Speed",
            url: "/pagespeed",
            icon: SquareTerminal,
            isActive: currentPath === '/pagespeed' || currentPath.includes('/pagespeed'),
        },
        {
            title: "HR Chatbot",
            url: "/hr-chatbot",
            icon: MessageSquare,
            isActive: currentPath === '/hr-chatbot',
        },
        {
            title: "Team Matching",
            url: "/team-matching",
            icon: Brain,
            isActive: currentPath === '/team-matching',
        },
        {
            title: "Billing",
            url: "/billing",
            icon: CreditCard,
            isActive: currentPath === '/billing',
        },
        {
            title: "Integrations",
            url: "/integrations",
            icon: Link,
            isActive: currentPath === '/integrations',
        },
        {
            title: "Notifications",
            url: "/notifications",
            icon: Bell,
            isActive: currentPath === '/notifications',
        },
        {
            title: "Settings",
            url: "/settings",
            icon: Settings,
            isActive: currentPath === '/settings' || currentPath.includes('/settings'),
            items: [
                {
                    title: "Developer",
                    url: "/settings/developer",
                },
            ],
        },
    ];

    return (
        <Sidebar collapsible="icon" className="sidebar-height">
            <SidebarHeader>
                <TeamSwitcher user={user}/>
            </SidebarHeader>
            <SidebarContent>
                {/*<ProjectSwitcher />*/}
                <NavMain items={navItems} />
            </SidebarContent>
            <SidebarFooter>
                <NavUser user={user}/>
            </SidebarFooter>
            <SidebarRail/>
        </Sidebar>
    );
}
